import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import "../hrmTour.css";

export function startOnLeaveListTour() {
  const steps = [{ popover: { title: "Hướng dẫn nhanh", description: "Giới thiệu các chức năng chính của màn nghỉ phép.", side: "over", align: "center" } }];
  const segments = [
    ['[data-tour="hrm-onleave-header"]', "Tiêu đề trang", "Hiển thị tổng số phiếu nghỉ phép và nút tour.", "bottom"],
    ['[data-tour="hrm-onleave-filter"]', "Bộ lọc nghỉ phép", "Lọc theo thời gian/đơn vị/trạng thái và tạo phiếu mới.", "bottom"],
    ['[data-tour="hrm-onleave-pending"]', "Phiếu chờ duyệt", "Khu vực xử lý các yêu cầu nghỉ phép đang chờ.", "top"],
    ['[data-tour="hrm-onleave-table"]', "Bảng nghỉ phép", "Danh sách chi tiết các phiếu nghỉ phép đã đăng ký.", "top"],
  ];
  for (const [selector, title, description, side] of segments) {
    const el = document.querySelector(selector);
    if (!el) continue;
    steps.push({ element: el, popover: { title, description, side } });
  }
  if (steps.length <= 1) return window.alert("Không tìm thấy vùng để chạy hướng dẫn.");
  driver({ showProgress: true, smoothScroll: true, popoverClass: "hrm-tour-popover", nextBtnText: "Tiếp", prevBtnText: "Trước", doneBtnText: "Xong", progressText: "Bước {{current}} / {{total}}", steps }).drive();
}
